import * as React from 'react';

import styles from './index.css';
import { BreadcrumbsContainer } from '../../breadcrumbs/container';

export class BreadcrumbsLayout extends React.Component {
  public render() {
    return (
      <div className={styles['container']}>
        <div className={styles['wrapper']}>
          <BreadcrumbsContainer linkLight />
        </div>
      </div>
    );
  }
}
